import axios from "./index";

// CategoriesApi class handles fetching product categories
class CategoriesApi {
  /**
   * Fetches the list of product categories by sending a GET request.
   * The request includes an Authorization header with the Bearer token.
   * @param {string} token - The authentication token for the user.
   * @returns {Promise} - The response containing the list of product categories.
   */
  static GetCategories = (token) => {
    return axios.get(`${base}/categories`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  static GetMainCategories = (token, page = 1) => {
    return axios.get(`${base}/main-categories?page=${page}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  static GetMainCategoryById = (token, id) => {
    return axios.get(`${base}/main-categories/${id}/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  static GetBrandCategories = (token, mainCategoryID) => {
    return axios.get(
      `${base}/main-categories/${mainCategoryID}/brand-categories/?page_size=25`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  };

  static GetAllBrandCategories = (token, page = 1) => {
    return axios.get(`${base}/brand-categories?page=${page}&page_size=25`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  static GetBrandCategoryById = (token, id) => {
    return axios.get(`${base}/brand-categories/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  static GetProductCategories = (token, mainCategoryID, brandCategoryID) => {
    return axios.get(
      `${base}/main-categories/${mainCategoryID}/brand-categories/${brandCategoryID}/product-categories`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  };

  static CreateMainCategory = (token, data) => {
    return axios.post(`${base}/main-categories`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  static UpdateMainCategory = (token, id, data) => {
    return axios.put(`${base}/main-categories/${id}/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  static DeleteMainCategory = (token, id) => {
    return axios.delete(`${base}/main-categories/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  static CreateBrandCategory = (token, data) => {
    return axios.post(`${base}/brand-categories`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  static UpdateBrandCategory = (token, id, data) => {
    return axios.put(`${base}/brand-categories/${id}/`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  };

  static DeleteBrandCategory = (token, id) => {
    return axios.delete(`${base}/brand-categories/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
}

// Base URL for the product-related API
let base = "product";

export default CategoriesApi;
